export function resizeChatHeight(element, {handleClick}) {

  const top = document.createElement("div");
  top.classList.add("grabber", "top");
  
  const grabberContent = document.createElement("div");
  grabberContent.classList.add("grabber-content");
  grabberContent.innerHTML = `
    <i id="grabber-icon" class="fa-thin fa-ellipsis"></i> 
    <i id="chat-close" class="fa-thin fa-xmark"></i>
  `;

  top.appendChild(grabberContent);
  element.appendChild(top);

  let active = null;
  let initialRect = null;
  let initialPos = null;

  function onChatCloseClick(event){
    if (handleClick) handleClick("chat");
  }

  function onMousedown(event) {
    event.preventDefault();
    event.stopPropagation();
    active = event.target;
    const rect = element.getBoundingClientRect();
    const parent = element.parentElement.getBoundingClientRect();

    initialRect = {
      height: rect.height,
      top: rect.top - parent.top,
    };
    initialPos = { y: event.pageY };
    active.classList.add("selected");
  }

  function onMouseup(event) {
    
    if (!active) return;

    event.preventDefault();
    event.stopPropagation();
    
    active.classList.remove("selected");
    active = null;
    initialRect = null;
    initialPos = null;
  
  }

  function onMove(event) {
    
    if (!active) return;

    event.preventDefault();
    event.stopPropagation();
    

    const delta = initialPos.y - event.pageY;
    const newHeight = initialRect.height + delta;

    // Constrain height between reasonable limits (e.g., 200px to 80vh)
    const minHeight = 200;
    const maxHeight = window.innerHeight * 0.8;

    if (newHeight >= minHeight && newHeight <= maxHeight) {
      element.style.height = `${newHeight}px`;
    }
  }

  top.addEventListener("mousedown", onMousedown);
  window.addEventListener("mousemove", onMove);
  window.addEventListener("mouseup", onMouseup);
  
  const closeIcon = grabberContent.querySelector('#chat-close');
  closeIcon.addEventListener('click', onChatCloseClick);

  return {
    destroy() {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onMouseup);
      closeIcon.removeEventListener('click', onChatCloseClick);
      element.removeChild(top);
    },
  };
}
